function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M169.676 57.477L155.801 49.0102L158.136 42.5923L172.011 51.0541L169.676 57.477Z",
  fill: "#275183"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.792 34.7434L158.016 43.6571L155.886 48.6638L154.159 52.7265L152.662 56.2568C152.211 57.3114 151.176 57.9341 150.101 57.904H150.091C149.755 57.8939 149.438 57.8236 149.107 57.688L149.057 57.668C148.504 57.4319 148.063 57.0352 147.786 56.5531C147.354 55.835 147.274 54.9461 147.621 54.1175L148.479 52.0887L149.408 49.8992L152.939 41.558L156.735 32.6041C157.318 31.2331 158.915 30.5853 160.286 31.1728L160.336 31.1929C161.732 31.7755 162.375 33.3724 161.792 34.7434Z",
  fill: "#275183"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M157.985 48.1315L157.975 48.4881C158.241 50.4918 156.734 52.2243 154.158 52.7265C152.601 53.0328 150.668 52.8922 148.489 52.0938C148.353 52.0435 148.212 51.9933 148.077 51.9381L147.851 51.9782L134.076 54.4942C134.066 54.4841 134.066 54.4841 134.056 54.4942L122.255 56.6435C122.134 56.6636 122.019 56.6536 121.918 56.6536C121.732 56.6737 121.562 56.6737 121.386 56.6737C121.21 56.6737 121.039 56.6636 120.864 56.6435H120.823C120.547 56.6134 120.281 56.5732 120.005 56.513C119.975 56.513 119.935 56.5029 119.904 56.4929C119.884 56.4828 119.864 56.4828 119.854 56.4728C119.834 56.4728 119.814 56.4627 119.794 56.4627C118.523 56.0961 117.409 55.3178 116.63 54.2632C116.048 53.4748 115.646 52.5357 115.505 51.4911L115.485 51.3706C115.405 50.778 115.415 50.1855 115.515 49.618C115.917 47.0719 117.951 44.9728 120.643 44.6112L122.466 44.551L146.806 43.7123C149.734 41.563 152.822 41.563 152.958 41.563C152.968 41.563 152.968 41.563 152.968 41.563C152.968 41.563 153.099 45.9521 157.739 43.7123C157.859 43.6521 157.955 43.632 158.025 43.6621C158.527 43.7525 157.955 45.4951 158.055 46.2936L157.985 48.1315Z",
  fill: "#AEC7E3"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "costume__body",
  d: "M117.921 59.9829H116.4L106.346 60.0181L85.0487 60.0683L84.3707 56.4626L83.9539 54.2631L83.9439 54.1727L80.5742 36.3101L80.7801 35.5518L81.6589 32.3479L82.6131 28.8376L83.9539 23.9363L99.9735 30.8564L102.57 35.0848L104.046 37.4651L110.052 47.2125L114.391 54.2631L114.557 54.5192L116.37 57.457L117.921 59.9829Z",
  fill: "#2A7771"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "costume__body",
  d: "M147.851 51.9831L134.077 54.499C134.067 54.4889 134.067 54.4889 134.056 54.499L122.255 56.6483C122.1 56.6684 121.959 56.6483 121.813 56.6584C121.627 56.6785 121.447 56.6785 121.261 56.6785C121.105 56.6684 120.965 56.6684 120.819 56.6483C120.543 56.6182 120.277 56.578 120 56.5178C119.97 56.5178 119.93 56.5077 119.9 56.4977C119.88 56.4876 119.86 56.4876 119.85 56.4776C119.83 56.4776 119.81 56.4675 119.789 56.4675C119.584 56.4173 119.383 56.3772 119.187 56.3018L114.562 54.5191L113.899 54.263L94.8612 46.9361C91.7577 45.7409 90.216 42.2709 91.4011 39.1674L91.4514 39.0569C91.8632 37.9822 92.5461 37.0934 93.4049 36.4456C95.0018 35.2152 97.1913 34.8285 99.2201 35.6069L104.051 37.47L122.466 44.5508L146.807 43.7121L147.625 50.1601L147.851 51.9831Z",
  fill: "#2A7771"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "costume__body",
  d: "M111.177 27.9186C111.187 28.1547 111.177 28.5213 111.127 28.9833C111.076 29.6712 110.971 30.54 110.84 31.449C110.82 31.6046 110.8 31.7553 110.78 31.911C110.76 32.0667 110.74 32.2173 110.72 32.373C110.464 34.1457 109.113 35.4313 107.466 35.7426C106.933 35.833 106.381 35.823 105.819 35.7025C104.764 35.4664 103.679 35.2605 102.574 35.0898C98.8884 34.4671 95.0116 34.1055 91.3055 33.7289C87.8354 33.3723 84.521 32.9907 81.6636 32.3579C80.2726 32.0516 78.992 31.6699 77.8671 31.223V31.2129C77.8269 31.2029 77.7868 31.1929 77.7466 31.1728C76.9782 30.8664 76.2852 30.5099 75.6575 30.0981C75.6575 30.0981 74.6029 19.708 74.4623 16.2278C74.0656 7.43966 81.5682 0.313698 90.3313 0.313698C90.3313 0.313698 103.227 0.313698 107.36 10.3724C107.636 11.0051 107.862 11.6831 108.048 12.4113C108.088 12.5468 108.119 12.6674 108.149 12.7979C109.163 17.1267 110.574 22.6156 111.046 26.4824C111.056 26.6029 111.076 26.7285 111.086 26.849C111.127 27.2306 111.157 27.5922 111.177 27.9186Z",
  fill: "#2A7771"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "costume__helmet",
  d: "M111.178 27.9186C111.188 28.1546 111.178 28.5212 111.128 28.9832C111.078 29.6712 110.972 30.54 110.842 31.4489C110.822 31.6046 110.802 31.7553 110.781 31.9109C110.761 32.0666 110.741 32.2173 110.721 32.373C110.465 34.1457 109.114 35.4312 107.467 35.7426C106.935 35.833 106.382 35.8229 105.82 35.7024C104.765 35.4664 103.681 35.2605 102.576 35.0898C98.8898 34.467 95.0129 34.1055 91.3068 33.7288C87.8368 33.3723 84.5224 32.9906 81.665 32.3579C80.2739 32.0516 78.9934 31.6699 77.8685 31.223V31.2129C77.8283 31.2029 77.7881 31.1928 77.7479 31.1727C77.3813 27.2607 76.613 18.5529 76.4975 16.1475C76.3519 12.6673 77.6324 9.33285 80.1233 6.73155C82.7748 3.9595 86.501 2.37261 90.3376 2.37261C90.8298 2.37261 101.26 2.51824 105.137 10.4276C105.453 11.0604 105.73 11.7383 105.935 12.4765C106.026 12.7427 106.101 13.0088 106.161 13.285C106.347 14.0835 106.548 14.9322 106.754 15.7909C107.799 20.0896 108.883 23.4994 109.059 26.5276V26.5677C109.059 26.5778 109.149 26.5778 109.305 26.5677C109.631 26.5577 110.269 26.5276 111.058 26.4974C111.068 26.6179 111.088 26.7435 111.098 26.864C111.128 27.2306 111.158 27.5922 111.178 27.9186Z",
  fill: "#3CA19D"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "costume__body",
  d: "M111.127 28.9834L99.5519 27.0399C94.8113 26.2414 91.3613 22.1788 91.3613 17.3679V14.9524C91.3613 12.6072 93.2646 10.6638 95.6098 10.6135L107.361 10.3775C108.697 10.9651 111.906 28.4058 111.127 28.9834Z",
  fill: "#2A7771"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M111.343 26.8994L99.8933 25.0212C96.1521 24.3935 93.4102 21.1544 93.4102 17.363V14.9575C93.4102 13.7071 94.4095 12.6876 95.6549 12.6625L108.315 12.4114C110.745 15.8112 112.051 23.0979 111.343 26.8994Z",
  fill: "#A5CDFF"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.8457 13.6616L98.3171 23.4492C98.8595 23.7053 99.4319 23.9112 100.055 24.0116L100.833 24.1372L99.0352 13.6164L96.8457 13.6616Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M99.8184 13.6015L101.747 24.2879L106.045 24.991L103.565 13.5262L99.8184 13.6015Z",
  fill: "white"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.671 30.5099C109.621 30.8966 109.264 31.1678 108.877 31.1126L104.745 30.5602C104.358 30.5099 104.087 30.1534 104.142 29.7667C104.192 29.38 104.549 29.1088 104.935 29.1591L109.068 29.7115C109.45 29.7667 109.721 30.1233 109.671 30.5099Z",
  fill: "#275183"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.29 33.1313C109.24 33.518 108.883 33.7892 108.497 33.734L104.364 33.1816C103.977 33.1313 103.706 32.7748 103.761 32.3881C103.811 32.0014 104.168 31.7303 104.554 31.7855L108.687 32.3379C109.069 32.3881 109.34 32.7447 109.29 33.1313Z",
  fill: "#275183"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  className: "costume__body",
  d: "M143.176 68.8716L140.504 69.198L112.081 72.6882C108.118 73.1803 104.518 70.3631 104.026 66.4059L104.015 66.2603C103.995 66.0845 103.975 65.9138 103.975 65.738C103.855 63.4983 104.784 61.4192 106.351 60.0181C107.305 59.1494 108.5 58.5216 109.851 58.2806C109.996 58.2505 110.147 58.2304 110.303 58.2103L116.374 57.462L135.964 55.0566L141.398 54.3887C143.517 54.1225 145.541 54.8105 147.037 56.1061L147.057 56.1262C148.253 57.1909 149.116 58.6522 149.403 60.3446C149.423 60.445 149.443 60.5605 149.453 60.671L149.473 60.8166C149.95 64.7738 147.133 68.3795 143.176 68.8716Z",
  fill: "#2A7771"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  className: "costume__body",
  d: "M179.046 82.1442L178.278 83.2289C176.259 86.6689 169.058 85.9508 165.618 83.937L140.499 69.198L138.596 68.0831C137.581 67.4805 136.763 66.672 136.17 65.7379C135.578 64.829 135.206 63.7945 135.085 62.7198C134.89 61.2032 135.186 59.6163 136.015 58.1952L136.085 58.0596C136.567 57.2511 137.17 56.5731 137.868 56.0308C140.127 54.248 143.341 53.9417 145.973 55.4884L147.027 56.1011L147.047 56.1211L147.786 56.553L150.091 57.9039H150.101L151.532 58.7526L173.005 71.3423C176.45 73.3611 181.065 78.6942 179.046 82.1442Z",
  fill: "#2A7771"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M143.142 65.6225V65.733H63.4004V61.5348C63.4305 59.3452 64.4048 57.3918 65.9515 56.071C67.2421 54.9461 68.9294 54.2581 70.7724 54.2581H131.782C132.561 54.2581 133.319 54.3385 134.052 54.4942C134.062 54.4841 134.062 54.4841 134.072 54.4942C134.725 54.6247 135.353 54.8105 135.956 55.0466C136.629 55.3127 137.266 55.6391 137.869 56.0308C140.194 57.5022 141.952 59.8173 142.71 62.5291C143.001 63.5184 143.142 64.5478 143.142 65.6225Z",
  fill: "#275183"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M180.113 79.4274C170.054 69.8659 171.711 71.4427 163.184 63.2622C158.569 58.838 157.334 51.933 160.136 46.183L161.225 43.9433C161.607 43.1599 162.501 42.7531 163.345 42.974C196.499 51.8024 208.647 61.2736 234.333 74.8676L218.499 82.1392L180.113 79.4274Z",
  fill: "#75B0FF"
});

var _ref19 =
/*#__PURE__*/
React.createElement("g", {
  className: "engine"
}, React.createElement("path", {
  className: "engine-paintable",
  d: "M65.77 78.6089H36.9799C35.3478 71.493 34.5845 64.4976 36.0257 57.7884C36.4626 55.7546 38.3157 54.3334 40.3947 54.3334H62.3802C64.5346 54.3334 66.4178 55.855 66.7894 57.9742C67.7586 63.5434 66.92 70.9205 65.77 78.6089Z",
  fill: "#275183"
}), React.createElement("path", {
  className: "engine-paintable",
  d: "M62.5764 60.2442H41.1232C40.5357 60.2442 40.0586 59.7671 40.0586 59.1795C40.0586 58.592 40.5357 58.1149 41.1232 58.1149H62.5764C63.164 58.1149 63.6411 58.592 63.6411 59.1795C63.6411 59.7671 63.164 60.2442 62.5764 60.2442Z",
  fill: "white"
}), React.createElement("path", {
  className: "engine-paintable",
  d: "M62.5764 63.2572H41.1232C40.5357 63.2572 40.0586 62.7802 40.0586 62.1926C40.0586 61.6051 40.5357 61.128 41.1232 61.128H62.5764C63.164 61.128 63.6411 61.6051 63.6411 62.1926C63.6411 62.7802 63.164 63.2572 62.5764 63.2572Z",
  fill: "white"
}), React.createElement("path", {
  className: "engine-paintable",
  d: "M62.5764 66.2702H41.1232C40.5357 66.2702 40.0586 65.7931 40.0586 65.2056C40.0586 64.618 40.5357 64.141 41.1232 64.141H62.5764C63.164 64.141 63.6411 64.618 63.6411 65.2056C63.6411 65.7931 63.164 66.2702 62.5764 66.2702Z",
  fill: "white"
}), React.createElement("path", {
  className: "engine-paintable",
  d: "M62.5764 69.2835H41.1232C40.5357 69.2835 40.0586 68.8064 40.0586 68.2189C40.0586 67.6313 40.5357 67.1543 41.1232 67.1543H62.5764C63.164 67.1543 63.6411 67.6313 63.6411 68.2189C63.6411 68.8064 63.164 69.2835 62.5764 69.2835Z",
  fill: "white"
}));

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M218.499 77.0925H23.668V89.3658H218.499V77.0925Z",
  fill: "#75B0FF"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M161.486 94.7642H51.0215C48.0385 94.7642 45.623 92.3487 45.623 89.3657V70.5239C45.623 68.1234 47.1899 65.9691 49.4999 65.3263C81.6646 56.3222 120.569 58.5719 162.385 65.6929C164.977 66.1348 166.875 68.3946 166.875 71.0261V89.3657C166.885 92.3487 164.464 94.7642 161.486 94.7642Z",
  fill: "#75B0FF"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M71.2045 66.9081C65.2587 67.6915 59.6041 68.7511 54.2107 70.1171C52.5886 70.5288 51.4688 72.0153 51.4688 73.6876V85.2478C51.4688 87.2766 53.1109 88.9187 55.1397 88.9187H71.6565C73.6853 88.9187 75.3274 87.2766 75.3274 85.2478V70.564C75.3324 68.3594 73.389 66.6219 71.2045 66.9081Z",
  fill: "white"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M237.291 92.7152H208.275C212.278 85.293 212.062 77.6498 208.275 69.8057L238.908 75.7565C242.896 76.5299 245.768 80.0201 245.768 84.0777V84.2334C245.773 88.9187 241.977 92.7152 237.291 92.7152Z",
  fill: "#75B0FF"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M216.551 86.8747C217.153 83.7713 217.219 80.6125 216.752 77.4086L237.798 81.4964C239.033 81.7374 239.927 82.8221 239.927 84.0826C239.927 85.6896 238.742 86.8747 237.291 86.8747H216.551Z",
  fill: "white"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.04 81.0044H122.211V88.9188H161.04V81.0044Z",
  fill: "white"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M83.9532 54.2633H70.7709L69.872 37.5607C69.7364 35.1753 71.6447 33.1616 74.0401 33.1616H77.0181C77.1386 33.1616 77.2541 33.1616 77.3646 33.1817C78.8711 33.3022 80.1567 34.2262 80.7844 35.557C80.9602 35.9035 81.0807 36.2851 81.141 36.6819L83.9432 54.1729L83.9532 54.2633Z",
  fill: "#75B0FF"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.191 99.9507C38.7663 97.4536 45.3149 86.8564 42.8178 76.2811C40.3207 65.7059 29.7234 59.1573 19.1482 61.6544C8.57293 64.1515 2.02431 74.7487 4.52143 85.324C7.01854 95.8992 17.6158 102.448 28.191 99.9507Z",
  fill: "#275183"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M33.6049 80.8083C33.6049 86.2971 29.1555 90.7465 23.6667 90.7465C18.1778 90.7465 13.7285 86.2971 13.7285 80.8083C13.7285 75.3194 18.1778 70.8701 23.6667 70.8701C29.1555 70.8701 33.6049 75.3194 33.6049 80.8083Z",
  fill: "#75B0FF"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.2174 80.8083C29.2174 83.8716 26.7316 86.3574 23.6683 86.3574C20.6049 86.3574 18.1191 83.8716 18.1191 80.8083C18.1191 77.745 20.6049 75.2592 23.6683 75.2592C26.7316 75.2542 29.2174 77.74 29.2174 80.8083Z",
  fill: "white"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M195.733 99.0073C205.784 94.8769 210.583 83.3811 206.452 73.3307C202.322 63.2804 190.826 58.4812 180.776 62.6116C170.726 66.7419 165.926 78.2377 170.057 88.2881C174.187 98.3385 185.683 103.138 195.733 99.0073Z",
  fill: "#275183"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  className: "cart",
  d: "M198.201 80.8083C198.201 86.2971 193.751 90.7465 188.262 90.7465C182.774 90.7465 178.324 86.2971 178.324 80.8083C178.324 75.3194 182.774 70.8701 188.262 70.8701C193.751 70.8701 198.201 75.3194 198.201 80.8083Z",
  fill: "#75B0FF"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M194.134 80.8084C194.134 84.0525 191.507 86.6789 188.263 86.6789C185.019 86.6789 182.393 84.0474 182.393 80.8084C182.393 77.5643 185.019 74.9379 188.263 74.9379C191.507 74.9328 194.134 77.5643 194.134 80.8084Z",
  fill: "white"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M74.4395 59.4205C72.9631 59.4205 71.7679 58.2253 71.7679 56.7489V51.4408C71.7679 50.8834 71.3109 50.4264 70.7535 50.4264H56.592C56.0346 50.4264 55.5776 50.8834 55.5776 51.4408V54.7352C55.5776 56.2116 54.3824 57.4068 52.906 57.4068C51.4296 57.4068 50.2344 56.2116 50.2344 54.7352V51.4408C50.2344 47.9306 53.0868 45.0782 56.597 45.0782H70.7585C74.2638 45.0782 77.1212 47.9306 77.1212 51.4408V56.7489C77.1162 58.2203 75.921 59.4205 74.4395 59.4205Z",
  fill: "#275183"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.636 69.1428C114.872 68.3494 114.636 67.7719 113.507 67.7719H109.77C108.821 67.7719 108.384 68.274 108.143 68.8264C108.143 68.8264 106.245 73.4566 103.553 76.4646C102.685 77.3334 102.288 77.6146 101.811 77.6146C101.575 77.6146 101.228 77.3384 101.228 76.545V69.1478C101.228 68.1987 100.952 67.7769 100.159 67.7769H94.288C93.6955 67.7769 93.3389 68.2188 93.3389 68.6356C93.3389 69.5345 94.6848 69.7454 94.8254 72.2764V77.7753C94.8254 78.9806 94.6094 79.2015 94.1324 79.2015C92.8669 79.2015 89.7885 74.5513 87.9605 69.2282C87.604 68.1937 87.2424 67.7769 86.2883 67.7769H82.552C81.4824 67.7769 81.2715 68.2791 81.2715 68.8315C81.2715 69.8208 82.537 74.7271 87.1671 81.2153C90.2555 85.6445 94.5994 88.05 98.5566 88.05C100.932 88.05 101.223 87.5177 101.223 86.5987V83.2491C101.223 82.1795 101.449 81.9685 102.202 81.9685C102.755 81.9685 103.704 82.2447 105.924 84.384C108.455 86.915 108.871 88.055 110.298 88.055H114.034C115.098 88.055 115.636 87.5227 115.324 86.4681C114.988 85.4185 113.778 83.8969 112.176 82.0891C111.307 81.0596 110.001 79.9548 109.605 79.3974C109.052 78.6843 109.208 78.3679 109.605 77.7352C109.615 77.7301 114.164 71.3223 114.636 69.1428Z",
  fill: "white"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M122.211 77.3283H161.04V71.3875C146.963 68.9971 134.103 67.3249 122.211 66.3356V77.3283Z",
  fill: "white"
});

var SvgCarInProfile = function SvgCarInProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 246 107",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCarInProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car-in-profile.ecf1e90a.svg";
export { ForwardRef as ReactComponent };